<template>
    <div>
        <!--顶部菜单-->
        <div>
            <el-menu class="el-menu-demo" mode="horizontal" background-color="#545c64"
                     :default-active="rootActiveRouter"
                     text-color="#fff" active-text-color="#ffd04b" router>
                <el-menu-item ><a href="http://www.haomiaodata.com/" target="_blank" style="color: #fff; text-decoration: none;">
                <img src="/logo.png" alt="Logo" style="width: 70px; height: 30px; vertical-align: middle; margin-right: 5px;">
                    浩淼数聚智能营销系统
                </a></el-menu-item>
                <!--<el-menu-item index="Task" :route="{name:'ActivityList'}">指标目录</el-menu-item>
                <el-menu-item index="Msg" :route="{name:'Push'}">实时数据</el-menu-item>-->
                <el-menu-item index="Auth" :route="{name:'Auth'}">公司信息库</el-menu-item>
                <el-menu-item index="company_search" :route="{name:'company_search'}">公司查询</el-menu-item>
                <!--<el-menu-item index="bidding" :route="{name:'bidding'}">招标信息</el-menu-item>
                <el-menu-item index="Public" :route="{name:'Public'}">招标语义检索小助手</el-menu-item>-->
                <el-menu-item index="auth" style="float: right;">
                </el-menu-item>
                <el-submenu index="5" style="float: right">
                    <template slot="title">{{username}}</template>
                    <el-menu-item index="5-1">个人中心</el-menu-item>
                    <el-menu-item index="5-2">注销</el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
        <div>
            <router-view></router-view>
        </div>


    </div>
</template>

<script>
    export default {
        name: "Layout",
        data() {
            return {
                rootActiveRouter: ""
            }
        },
        mounted() {
            // 获取当前的所有路由
            this.rootActiveRouter = this.$route.matched[1].name;
        },
        computed: {
            username() {
                return this.$store.state.username;
            }
        }
    }
</script>

<style scoped>

</style>
